<button type="button" class="ia-account-trigger" [class.ia-account-trigger--compact]="compact" [matMenuTriggerFor]="accountMenu"
  aria-label="Account menu" [title]="userName || 'Account menu'">
  <span class="ia-account-avatar" aria-hidden="true">{{ initials }}</span>
  <span *ngIf="!compact" class="ia-account-name">{{ userName || 'Account' }}</span>
  <i *ngIf="!compact" class="la la-angle-down" aria-hidden="true"></i>
</button>
<mat-menu #accountMenu="matMenu" xPosition="before">
  <div class="ia-account-identity" role="none">
    <span>Signed in as</span>
    <strong>{{ userName || 'Current user' }}</strong>
  </div>
  <button type="button" mat-menu-item (click)="signedOut.emit()">
    <i class="la la-sign-out" aria-hidden="true"></i> Sign out
  </button>
</mat-menu>
